export default function waitFor(conditionFunction: () => boolean) {
  const poll = (resolve: any) => {
    if (conditionFunction()) resolve()
    else setTimeout(() => poll(resolve), 250)
  }

  return new Promise(poll)
}
